<template>
  <div>
    <h4 class="mb-2">Two-factor authentication</h4>
    <p class="mb-4 text-sm">
      <span v-if="method === 'email'">We just sent a 6-digit code to your email. Enter it below.</span>
      <span v-else-if="method === 'totp'">Open your authenticator app and enter the current 6-digit code.</span>
      <span v-else>Enter the verification code from your second factor.</span>
    </p>

    <vs-input
      v-model="code"
      :label-placeholder="useRecovery ? 'Recovery code (XXXX-XXXX-XXXX)' : '6-digit code'"
      icon-pack="feather"
      icon="icon-shield"
      icon-no-border
      class="w-full"
      :maxlength="useRecovery ? 14 : 6"
      autocomplete="one-time-code"
      @keyup.enter="submit"
    />

    <div class="mt-4 flex items-center">
      <vs-checkbox v-model="rememberDevice">Trust this device for 24 hours</vs-checkbox>
    </div>
    <p class="text-xs mt-1 text-grey" style="margin-left: 26px;">
      Skip the 2FA step on this browser for the next 24 hours. Don't check this on a shared computer.
    </p>

    <div class="mt-4 flex justify-between items-center">
      <a href="#" @click.prevent="toggleRecovery" class="text-sm">
        <span v-if="!useRecovery">Use a recovery code instead</span>
        <span v-else>Back to {{ method === 'email' ? 'email code' : 'authenticator code' }}</span>
      </a>
      <vs-button color="success" :disabled="!canSubmit" @click="submit">Verify</vs-button>
    </div>

    <div class="mt-3" v-if="error">
      <vs-alert color="danger" icon-pack="feather" icon="icon-alert-circle">{{ error }}</vs-alert>
    </div>

    <div class="mt-6">
      <a href="#" @click.prevent="$emit('cancel')" class="text-xs">Cancel and sign in as a different user</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoFAChallenge',
  props: {
    challengeToken: { type: String, required: true },
    method: { type: String, default: null } // 'email' | 'totp'
  },
  data () {
    return {
      code: '',
      useRecovery: false,
      rememberDevice: true,
      error: null,
      submitting: false
    }
  },
  computed: {
    canSubmit () {
      if (this.submitting) return false
      if (this.useRecovery) return this.code.replace(/[^A-Z0-9]/gi, '').length >= 12
      return /^\d{6}$/.test(this.code)
    }
  },
  methods: {
    toggleRecovery () {
      this.useRecovery = !this.useRecovery
      this.code = ''
      this.error = null
    },
    submit () {
      if (!this.canSubmit) return
      this.submitting = true
      this.error = null
      this.$vs.loading()
      this.$store.dispatch('auth/submit2faChallenge', {
        challengeToken: this.challengeToken,
        code: this.code.trim(),
        useRecovery: this.useRecovery,
        rememberDevice: this.rememberDevice
      })
        .then(() => {
          this.$vs.loading.close()
          this.submitting = false
          this.$vs.notify({
            title: 'Welcome back',
            text: 'Two-factor verification successful.',
            iconPack: 'feather',
            icon: 'icon-thumbs-up',
            color: 'success',
            position: 'bottom-right',
            time: 3000
          })
        })
        .catch(err => {
          this.$vs.loading.close()
          this.submitting = false
          this.error = (err && err.message) || 'Verification failed.'
        })
    }
  }
}
</script>
